<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar
      v-if="showNavbar"
      :docsName="docsName"
    />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div
          v-if="showNavbar"
          class="col-xl-12"
        >
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t('global.save') }}
                  </button>
                  <button
                    class="btn btn-primary mr-2"
                    @click="abbrechen"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-list"
                      class="mr-2"
                    />
                    {{ $t('global.tolist') }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_umfragen.delete && editable"
                  >
                    <font-awesome-icon icon="fa-duotone fa-trash" />
                    <span>{{ $t('global.delete') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- START Linke Seite -->
        <div
          class="col-xl-12 pr-3"
          :class="{ 'col-xl-12': !showNavbar }"
        >
          <!-- START Daten -->
          <container-headline
            :headline="$t('global.masterdata')"
            :col="2"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <input
                          v-model="regel.bezeichnung"
                          v-bind:class="{ 'border-danger': !passed }"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{ $t('global.designation') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-2">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="regel.anzahl_ungenuegende"
                          :readonly="!editable"
                        />
                      </div>
                      <!-- TODO: add translation -->
                      <label>Anzahl ungenügende Noten</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="form-group">
                      <input
                        class="form-control"
                        v-model="regel.min_note"
                        :readonly="!editable"
                      />
                      <!-- TODO: add translation -->
                      <label>Minimal Note</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="regel.notendurchschnitt"
                          :readonly="!editable"
                        />
                      </div>
                      <!-- TODO: add translation -->
                      <label>Notendurchschnitt</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="form-group">
                      <v-select
                        v-model="regel.textwahl_wert"
                        class="w-100"
                        label="bezeichnung"
                        :options="textwahlwerte"
                        :disabled="!editable"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <!-- TODO: add translation -->
                      <label>Textwahl Wert</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          v-model="regel.anwesenheit"
                          class="form-control"
                          :readonly="!editable"
                        />
                      </div>
                      <!-- TODO: add translation -->
                      <label>Anwesenheit in %</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal
      id="regel-loeschen-modal"
      @confirmed="regelLoeschen"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import Navbar from '@/components/Navbar'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import AppApi from '@/api/AppApi'
  import store from '@/store'
  import page from '@/mixins/Page'
  import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
  import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import { LADE_AUSWAHLWERTE_NOTEN } from '@/store/noten/actions.type'

  export default {
    name: 'regel',
    components: {
      HeadMenu,
      Navbar,
      ContainerHeadline,
      LoeschenModal,
      UnsavedChangesModal,
    },
    mixins: [page, ChangeWatcherNew],
    store,
    props: {
      id: {
        type: String,
        default: null,
      },
      anzeige: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        editable: true,
        regel: {
          id: null,
          bezeichnung: null,
          anzahl_ungenuegende: null,
          min_note: null,
          notendurchschnitt: null,
          textwahl_wert: {
            id: null,
            kuerzel: null,
            bezeichnung: null,
            sortierung: null,
            wert: null,
            textwahlId: null,
            uebersetzungId: null,
          },
          anwesenheit: null,
        },
      }
    },
    computed: {
      queryParams: function () {
        var params = {
          page: this.page,
          count: this.anzahlProPage,
        }
        return params
      },

      navbarTitel: function () {
        if (this.id) {
          // TODO: change variable
          return 'Regel'
        } else {
          return 'Neue Regel'
        }
      },
      textwahlwerte: {
        get() {
          return this.$store.state.noten.textwahlwerte
        },
      },
    },
    watch: {},
    created() {
      this.loading = true
      if (this.id) this.loadRegel()
      this.loading = false
    },
    mounted() {
      // load textwahlwerte
      this.$store.dispatch(`noten/${LADE_AUSWAHLWERTE_NOTEN}`)
    },
    methods: {
      async loadRegel() {
        if (this.id) {
          // TODO: update path
          await AppApi.get('regel/', {
            params: { id: this.id },
          }).then((response) => {
            console.log(response.data)
            this.initializeRegel(response.data)
            this.loading = false
          })
        }
      },

      abbrechen() {
        this.$router.push({ name: 'einstellungen-regelnliste' })
      },

      initializeRegel(regel) {
        if (regel) {
          this.regel = regel
        } else {
          console.error('regel ist null')
        }
      },

      speichern() {
        if (this.loading) return
        this.loading = true
        var json = this.regel
        console.log(json)
        if (!this.id) {
          // TODO: update path
          AppApi.post('regel/', json)
            .then((response) => {
              this.initializeRegel(response.data)
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                // TODO: update translated value
                text: this.$t('global.regelsavedsuccessfully'),
              })

              this.$router.replace({
                name: 'einstellungen-regel',
                params: { id: response.data.id, anzeige: 0 },
              })
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          // TODO: update path
          AppApi.put('regel/', json)
            .then((response) => {
              this.loadRegel()
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                // TODO: update translated value
                text: this.$t('global.regelsavedsuccessfully'),
              })
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
            .finally(() => {
              this.loading = false
            })
        }
      },

      oeffneLoeschenModal() {
        this.$bus.$emit('openLoeschenModal', 'regel-loeschen-modal')
      },

      regelLoeschen() {
        AppApi.delete('regel/', { data: [this.id] })
          .then(() => {
            this.$router.push({ name: 'einstellungen-regelnliste' })
          })
          .catch((e) => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              // TODO: add translation
              text: this.$t('global.regelcouldnotbedeleted'),
            })
          })
      },
    },
  }
</script>

<style></style>
